module.exports = __webpack_public_path__ + "static/media/leaqd-subbanner.6abe5068.png";